import clsx from 'clsx';
import type { InputState } from '../Input';
import styles from './InputStateMessage.module.scss';

interface InputStateMessageProps {
  children: React.ReactNode;
  id: string;
  state: InputState;
}

export const InputStateMessage = ({ children, id, state }: InputStateMessageProps) => (
  <p
    className={clsx(styles.message, {
      [styles.success]: state === 'success',
      [styles.error]: state === 'error',
    })}
    id={id}
  >
    {children}
  </p>
);
